module.exports = __webpack_public_path__ + "cff3d554a4947671102cf3073ec34159.pdf";